/* eslint consistent-return: off */
import { useEffect } from 'react';
/**
 * Sensor hook that determine if the mouse element is in the hover element
 *
 * @param  {} ref
 * @param  {} handler
 */

export default ((ref, handler) => {
  useEffect(() => {
    const handleMouseEnter = () => handler(true);

    const handleMouseLeave = () => handler(false);

    const node = ref == null ? void 0 : ref.current;

    if (node) {
      node.addEventListener('mouseenter', handleMouseEnter);
      node.addEventListener('mouseleave', handleMouseLeave);
      return () => {
        node.removeEventListener('mouseenter', handleMouseEnter);
        node.removeEventListener('mouseleave', handleMouseLeave);
      };
    }
  }, [ref]);
});